import { CALL_API } from 'assets/js/apiMiddleware'
import { actionTypes } from 'assets/js/actionTypes'

export const mergeEntityActions = actionTypes('MERGE_ENTITY')

export default function(state = { merging: false }, action = {}) {
  switch (action.type) {
    case mergeEntityActions.BEGIN:
      return { ...state, merging: true }
    case mergeEntityActions.SUCCESS:
      return { ...state, merging: false, merged: true, error: null }
    case mergeEntityActions.ERROR:
      return { ...state, merging: false, merged: false, error: action.response }
    default:
      return {}
  }
}

export const mergeEntity = (route, entity, method = 'post') => {
  return dispatch => {
    return dispatch({
      [CALL_API]: {
        type: mergeEntityActions,
        endpoint: route,
        method: method,
        data: entity
      }
    })
  }
}
